<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div
			>场均销售额 <span class="yx-color-text-primary font-bold">{{ row.live_sale }}</span></div
		>
		<div
			>直播观看人数 <span class="yx-color-text-primary font-bold">{{ row.live_viewer }}</span></div
		>
		<div
			>直播带货场次 <span class="yx-color-text-primary font-bold">{{ row.live_num }}</span></div
		>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped></style>
